/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, TextField } from '@components/atoms'

import { Path } from '@utils'
import {
	useAppDispatch,
	useAppSelector,
	EditMenuType,
	adminActions,
	AdminStateType,
} from '@redux/index'
import { useDebounce } from 'use-debounce'
import { produce } from 'immer'

interface PropsType {
	readOnly?: boolean
}

export const AdminEditMenuId = (props: PropsType) => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const editTempMenu: EditMenuType = useAppSelector(state => state.admin.editTempMenu)
	const editMenuMode: AdminStateType['editMenuMode'] = useAppSelector(
		state => state.admin.editMenuMode,
	)

	// variables
	const readOnly: boolean = props.readOnly ?? false
	const disabled: boolean = editMenuMode === 'update' && editTempMenu.id === ''

	// state
	const [name, setName] = React.useState(editTempMenu.name)

	// hook
	const [debouncedName] = useDebounce(name, 1000)

	React.useEffect(() => {
		setName(editTempMenu.name)
	}, [editTempMenu.name])

	React.useEffect(() => {
		onNameChange(debouncedName)
	}, [debouncedName])

	const onNameChange = (debouncedName: string) => {
		const newName: string = debouncedName.trim()
		const newPath: string = Path.getPathByName(editTempMenu.path, newName)
		const newUri: string = Path.getUriByPath(newPath)

		const newMenu: EditMenuType = produce(editTempMenu, draft => {
			draft.name = newName.trim()
			draft.path = newPath
			draft.uri = newUri
		})

		reduxDispatch(adminActions.EDIT_TEMP_MENU({ ...newMenu }))
	}

	return (
		<View css={style}>
			<TextField
				autoFocus={true}
				margin="dense"
				id="name"
				label="영문 이름"
				type="default"
				fullWidth={true}
				variant="standard"
				value={name ?? ''}
				onChange={e => setName(e.target.value)}
				autoComplete="off"
				disabled={disabled || readOnly}
				inputProps={{
					maxLength: 30,
					style: {
						height: '1.5rem',
						paddingTop: '0.5rem',
					},
				}}
			/>
		</View>
	)
}

const style = css({
	width: '100%',
	marginTop: '0.5rem',

	'.menuIdView': {
		position: 'relative',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		marginTop: 0,

		'.menuIdText': {
			marginLeft: '1rem',
		},
	},
})
